import React, { useState } from "react";
import { useEffect } from "react";
import Main from "./Main";
import "primeicons/primeicons.css";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";

import { getDocs, collection, orderBy, query, where } from "firebase/firestore";
import { db } from "../firebase/Firebase";

import Spinner from "react-bootstrap/Spinner";

//
function Profile() {
  const eventCollectionRef = collection(db, "events");
  const [loading, setLoading] = useState(false);

  const [counter, setCounter] = useState(0);

  const [totalCount, setTotalCount] = useState(0);
  const [todayCount, setTodayCount] = useState(0);
  const [thisMonthCount, setThisMonthCount] = useState(0);
  const [thisWeekCount, setthisWeekCount] = useState(0);

  useEffect(() => {
    setLoading(true);
    const userValue = JSON.parse(localStorage.getItem("user"));
    const eventQuery = query(
      eventCollectionRef,
      where("userID", "==", userValue.uid)
    );

    const getEventList = async () => {
      try {
        const data = await getDocs(eventQuery);

        const filteredData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          created_at: doc.data().created_at?.toDate(), // Assuming created_at is a Firestore Timestamp
        }));

        const now = new Date();
        const startOfDay = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate()
        );
        const endOfDay = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() + 1
        );
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const startOfWeek = new Date(now);
        startOfWeek.setDate(now.getDate() - now.getDay());

        const todayEvents = filteredData.filter(
          (event) =>
            event.created_at >= startOfDay && event.created_at < endOfDay
        );
        const thisMonthEvents = filteredData.filter(
          (event) => event.created_at >= startOfMonth
        );
        const thisWeekEvents = filteredData.filter(
          (event) => event.created_at >= startOfWeek
        );

        setLoading(false);
        setTotalCount(filteredData.length);
        setTodayCount(todayEvents.length);
        setThisMonthCount(thisMonthEvents.length);
        setthisWeekCount(thisWeekEvents.length);
      } catch (error) {
        setLoading(false);
      }
    };

    getEventList();
  }, [counter]);

  return (
    <>
      <Main />
      <Container fluid="md">
        <Row className="p-1">
          <Col>
            <Card
              style={{ width: "18rem" }}
              className="m-1 bg-primary text-white"
            >
              <Card.Body>
                <Card.Title className="text-center">Today Tasks</Card.Title>
                {loading && (
                  <Card.Text className="text-center">
                    <Spinner size="sm" role="status" aria-hidden="true" />
                  </Card.Text>
                )}
                {!loading && (
                  <Card.Text className="text-center">{todayCount}</Card.Text>
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col>
            <Card
              style={{ width: "18rem" }}
              className="m-1 bg-success text-white"
            >
              <Card.Body>
                <Card.Title className="text-center">This week Tasks</Card.Title>
                {loading && (
                  <Card.Text className="text-center">
                    <Spinner size="sm" role="status" aria-hidden="true" />
                  </Card.Text>
                )}
                {!loading && (
                  <Card.Text className="text-center">{thisWeekCount}</Card.Text>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card
              style={{ width: "18rem" }}
              className="m-1 bg-danger text-white"
            >
              <Card.Body>
                <Card.Title className="text-center">
                  This Month Tasks
                </Card.Title>
                {loading && (
                  <Card.Text className="text-center">
                    <Spinner size="sm" role="status" aria-hidden="true" />
                  </Card.Text>
                )}
                {!loading && (
                  <Card.Text className="text-center">
                    {thisMonthCount}
                  </Card.Text>
                )}
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <Card
              style={{ width: "18rem" }}
              className="m-1 bg-secondary text-white"
            >
              <Card.Body>
                <Card.Title className="text-center">Total tasks</Card.Title>
                {loading && (
                  <Card.Text className="text-center">
                    {" "}
                    <Spinner size="sm" role="status" aria-hidden="true" />
                  </Card.Text>
                )}
                {!loading && (
                  <Card.Text className="text-center">{totalCount}</Card.Text>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Profile;
